module.exports = __webpack_public_path__ + "img/a1.34542ca8.jpg";